import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NfpLogo } from "@/components/Brand";

const navItems = [
  { label: "Programs", href: "#programs" },
  { label: "Features", href: "#features" },
  { label: "No Fatigue Score", href: "#fatigue-score" },
  { label: "Pricing", href: "#pricing" },
  { label: "Support", href: "#support" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <NfpLogo />

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) =>
            item.href.startsWith("#") ? (
              <a
                key={item.label}
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-white/70 hover:text-white transition-colors tracking-wide"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.href}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className="text-sm text-white/70 hover:text-white transition-colors tracking-wide"
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="https://apps.apple.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-download"
            className="nfp-btn nfp-btn-primary text-sm py-2.5 px-5"
          >
            Get the App
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-white/10" data-testid="nav-mobile-menu">
          <div className="px-6 py-5 flex flex-col gap-5">
            {navItems.map((item) =>
              item.href.startsWith("#") ? (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="text-base text-white/80 hover:text-white"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  onClick={() => setOpen(false)}
                  className="text-base text-white/80 hover:text-white"
                >
                  {item.label}
                </Link>
              )
            )}
            <a href="https://apps.apple.com/" target="_blank" rel="noopener noreferrer" className="nfp-btn nfp-btn-primary mt-2 self-start">Get the App</a>
          </div>
        </div>
      )}
    </header>
  );
}
